import { Navigate } from "react-router-dom";

export const NoMatch = () => {
  return <Navigate to="/" replace />;
};
